import axios from 'axios';
import { API_ROOT, logApiError } from '@/store/api';


export default {
    namespaced: true,
    actions: {
        async generateComparisonCapGainsReport({ dispatch }, payload) {
            const baseUrl = `${API_ROOT}/reports/comparison/capital_gains/`;
            const params = new URLSearchParams();
            for (const key in payload) {
                const value = payload[key];
                if (Array.isArray(value)) {
                    value.forEach(val => params.append(key, val));
                } else {
                    params.append(key, value);
                }
            }
            const fullUrl = `${baseUrl}?${params.toString()}`;

            try {
                window.open(fullUrl, '_blank');
            } catch (e) {
                logApiError(e, dispatch);
                return false;
            }
        },
        async generateCrutReport({ dispatch }, payload) {
            try {
                const { data } = await axios.post(
                    `${API_ROOT}/reports/crut/`,
                    payload,
                );

                return { data };
            } catch (e) {
                logApiError(e, dispatch);
                return false;
            }
        },
        async generateQsbsReport({ dispatch }, payload) {
            try {
                const { data } = await axios.post(
                    `${API_ROOT}/reports/qsbs/`,
                    payload,
                );

                return { data };
            } catch (e) {
                logApiError(e, dispatch);
                return false;
            }
        },
        async generateSolarReport({ dispatch }, payload) {
            try {
                const { data } = await axios.post(
                    `${API_ROOT}/reports/solar/`,
                    payload,
                );

                return { data };
            } catch (e) {
                logApiError(e, dispatch);
                return false;
            }
        },
    },
};
